import { name } from "next/dist/telemetry/ci-info";
import {msjtradeshow} from "styles/themes/msj";

export const montmagny = {
  body_background_color: '#eee',

  header_background_color: '#008BCB',
  header_border_color: 'white',

  logo_image_url: 'montmagny.png',
  logo_height: 140,

  token_url: 'montmagny.png',
  token_width: 60,
  token_margin_left: 10,

  number_hidden: true,

  button_color: '#ff941f',
  button_radius: 50,
  button_hover_color: '#e5851b',
  button_hover_text_color: 'white',
  button_hover_border_color: '#e5851b',

  button_half_border_color: '#ff941f',

  text_font: 'Roboto Condensed, sans-serif',
  title_font: 'Roboto Condensed, sans-serif',

  footer_font: 'Open Sans, sans-serif',
}

export const montmagny_cimetiere = {
  ...montmagny,
  body_background_color: '#ffffff',
  header_background_color: '#ffffff',
  header_border_color: 'white',
  logo_image_url: 'montmagny_cimetieres.png',
  logo_height: 140,
  header_full_height: true,

  token_url: 'montmagny_cimetieres.png',

  title_font: 'Roboto Condensed, sans-serif',
  title_weight: 700,
  subtitle_font: 'Roboto Condensed, sans-serif',
  subtitle_weight: 700,

  button_hover_color: 'white',
  button_hover_text_color: '#38830d',
  button_hover_border_color: '#38830d',
  button_color: '#38830d',
  button_half_border_color: '#38830d',
  button_border_width: 3,
  button_radius: 10,
}

export const montmagny_hockey = {
  name: "Montmagny Hockey",

  logo_image_url: 'montmagny/hockey.webp',
  logo_height: '200px',
  logo_padding: '0',
  header_padding: '0px',
  
  body_background_color: '#e3ded1',

  card_background_color: '#f0ebdb',

  title_font: 'Komu, normal',
  title_color: '#c63a3a',
  subtitle_font: `Roboto Condensed, normal`,
  subtitle_weight: 700,
  text_font: 'Roboto Condensed, normal',

  token_hidden: true,

  number_hidden: true,

  button_color: '#004879',
  button_border_color: '#c63a3a',
  button_outlined_text_color: '#FFFFFF',
  button_outlined_color: '#c63a3a',
  button_half_border_color: '#c63a3a',
  button_outlined_hover_color: '#004879',
  button_outlined_hover_border_color: '#c63a3a',
  button_radius: 10,
  button_border_width: 2,

  footer_font: 'Open Sans, sans-serif',
}